import { Component, OnDestroy, OnInit } from '@angular/core';
import { ERROR_PAGE_DEFAULT_CONTENT, LIFERAY_WEB_CONSTANT } from '../../../utils/liferay.constant';
import { IErrorPageContent } from '../../../services/liferay/liferay.interface';
import { catchError, of, Subject, takeUntil } from 'rxjs';
import { LiferayService } from '../../../services/liferay/liferay.service';
import { RouterService } from '../../../services/router/router.service';
import { APP_ROUTES } from '../../../utils/route.constant';
import { trackByIndex } from '../../../utils/helper';

@Component({
  selector: 'app-api-error',
  templateUrl: './api-error.component.html',
  styleUrls: ['./api-error.component.css']
})
export class ApiErrorComponent implements OnInit, OnDestroy{
  public pageWebContent: IErrorPageContent[] | undefined;
  public pageContent: IErrorPageContent[] | undefined;
  cleaner$: Subject<void> = new Subject();
  trackByIndex = trackByIndex;
  constructor(
    private lifeRayService: LiferayService,
    private routerService: RouterService
  ) { }

  ngOnInit(): void {
    this.getErrorPageContent();
  }


  getErrorPageContent(): void {
    let content = LIFERAY_WEB_CONSTANT.error_content;
    this.lifeRayService
      .getWebContent<IErrorPageContent[]>(content.type, content.id)
      .pipe(
        takeUntil(this.cleaner$),
        catchError(() => of({ value: ERROR_PAGE_DEFAULT_CONTENT } as any))
      )
      .subscribe(data => {
        this.pageWebContent = data.value;
        if (this.pageWebContent) {
          this.pageContent = this.pageWebContent;
        } else {
          this.pageContent = ERROR_PAGE_DEFAULT_CONTENT;
        }
      });
  }

  navigateToLogin(): void {
    this.routerService.goto(APP_ROUTES.LOGIN);
  }

  navigateToContactUs(): void {
    window.location.href = 'https://www.cinchhomeservices.com/contact-us';
  }

  ngOnDestroy(): void {
    this.cleaner$.next();
    this.cleaner$.complete();
  }
}
